import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

export const Modal = forwardRef(({ children, fullHeight, ...rest }, ref) => {
	return (
		<ReactModal ref={ref} closeTimeoutMS={200} {...rest} style={{ content: { height: fullHeight ? '100%' : 'auto' } }}>
			{children}
		</ReactModal>
	);
});

Modal.displayName = 'Modal';

Modal.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	fullHeight: PropTypes.bool,
};
